import { Button } from 'antd';
import { FaCamera } from 'react-icons/fa';
import './styles.less';
import { useDisclosure } from '@/hooks';
import VisionModal from './VisionModal';
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

export default function Vision() {
  const history = useHistory();

  const hasPermission = hasPermissions([
    Authorities.MOVIMENTATION_WORKORDER_VISION,
  ]);

  const [prevPathname, setPrevPathname] = useState(history.location.pathname);

  const ultracarVisionVisualized = localStorage.getItem(
    '@ultracar-vision-visualized',
  );

  const [hasVisualized, setHasVisualized] = useState(() => {
    return ultracarVisionVisualized
      ? JSON.parse(ultracarVisionVisualized)
      : false;
  });

  const [opened, action] = useDisclosure(false, {
    onOpen: () => {
      if (!hasVisualized) {
        localStorage.setItem('@ultracar-vision-visualized', 'true');
        setHasVisualized(true);
      }
    },
  });

  useEffect(() => {
    const meta = document.createElement('meta');
    meta.setAttribute('name', 'apple-mobile-web-app-capable');
    meta.setAttribute('content', 'yes');
    meta.setAttribute('id', 'meta-apple-mobile');

    const metaElement = document.getElementById('meta-apple-mobile');

    if (opened && !metaElement) {
      document.head.appendChild(meta);
    }

    if (!opened && metaElement) {
      document.head.removeChild(metaElement);
    }
  }, [opened]);

  useEffect(() => {
    if (prevPathname !== history.location.pathname) {
      action.close();
      setPrevPathname(history.location.pathname);
    }
  }, [history.location.pathname]);

  if (!hasPermission) return null;

  return (
    <>
      <Button
        shape="circle"
        size="large"
        className="vision-button"
        icon={<FaCamera />}
        type="primary"
        onClick={action.open}
      />

      <VisionModal opened={opened} onClose={action.close} />
    </>
  );
}
